/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theming */
import './app.css';
import './variables.css';

/* Windy */
import '../weather/windy/windy.css';

// exposing this as a no-op component b/c that is easier to reason about
// and is more flexible when looking at the implementation of <AutoPylotApp />
export const AutoPylotTheme = () => null;
